// extracted by mini-css-extract-plugin
module.exports = {"title_zing":"subtitle_title_zing__3MNwj","title_fnc":"subtitle_title_fnc__Xz4-H","root":"subtitle_root__kmMR5"};